export enum EditMode {
    NOT_EDITING = 'not editing',
    CROP_SCALE = 'Crop/Scale',
}
